import concat from "ramda/es/concat";
import filter from "ramda/es/filter";
import has from "ramda/es/has";
import into from "ramda/es/into";
import map from "ramda/es/map";
import mergeWith from "ramda/es/mergeWith";
import o from "ramda/es/o";
import pick from "ramda/es/pick";
import isNotEmpty from "ramda-extension/es/isNotEmpty";
import { from, of, pipe, zip } from 'rxjs';
import { map as rxMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { metaFieldIndices, metaFieldName, payloadInitiallyDirty } from '../../../utils/data';
import validateFields, { validateFieldsAsync } from '../../../validations/validateFields';
export const mapDirtyFieldNames = into([], o(filter(payloadInitiallyDirty), map((action)=>[
        metaFieldName(action),
        metaFieldIndices(action)
    ])));
export const validateSyncAndAsyncFields = ({ formData$, formDescriptor$, formFieldState$ }, reduxStore, mapFn)=>pipe(withLatestFrom(formData$, formDescriptor$, formFieldState$), rxMap((value)=>mapFn(value, reduxStore)), switchMap((validationParams)=>zip(of(validateFields(validationParams)), from(validateFieldsAsync(validationParams)))), rxMap(([syncResult, asyncResult])=>mergeWith(concat, syncResult, asyncResult)));
export const hasDependentFieldsWithAsyncValidations = (fieldName, formDescriptor)=>{
    const dependentFieldList = formDescriptor?.[fieldName]?.dependentFields;
    if (dependentFieldList) {
        const dependentFields = pick(dependentFieldList, formDescriptor);
        return o(isNotEmpty, filter(has('asyncValidations')), dependentFields);
    } else {
        return false;
    }
};
